<template>
    <v-row class='justify-center'>
        <v-col lg=3 md=12>
            <v-card min-height='300' class='pa-10' color='#fbfbfb'>
                <v-card-title><h2>Login</h2></v-card-title>
                <v-card-text>
                <v-form class='pb-3' ref="form">
                    <v-text-field  :rules="[rules.required]" solo v-model="email" type='email' label='Email' name='email'></v-text-field>
                    <v-text-field :rules="[rules.required]" solo v-model="password" type='password' label='Password' name='password'></v-text-field>
                    <v-btn @click="userLogin" color='primary'>Login</v-btn>
                </v-form>

                <p class='text-center'>Not yet registered?</p>
                <a @click="$router.push({ path: '/signup' })"><p class='text-center'>Signup</p></a>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
  
</template>
<script>
/*global myBaseURL*/

import axios from 'axios';

export default {
    name: 'Login',
    data() {
        return {
            email: '',
            password: '',
            rules:{
                required: value => !!value || 'Required.',
                counter: value => value.length <= 25 || 'Max 25 characters',
            },
        }
    },
    methods: ({
        userLogin(){
            if(this.$refs.form.validate())
            {
                var that = this;
                axios.request({
                    url: '/seller/login',
                    method: 'POST',
                    baseURL: myBaseURL,
                    data : {
                        'email' : that.email,
                        'password' : that.password
                    }
                }).then(response => {
                    console.log(response.data.access_token);
                    localStorage.setItem('access_token', response.data['access_token']);
                    if(response.data['stores_count'] > 0)
                    {
                        that.$router.push({ name: 'Catalogue', params : {store_slug : response.data.store_slug} })
                    }
                    else
                    {
                        that.$router.push({ path: '/addStore' });
                    }
                    console.log('Submit Success')
                }).catch(e => {
                    console.log(e);
                    console.log('Submit Fail')
                });
            }
        }
    })
}
</script>